module.exports = __webpack_public_path__ + "static/media/video player backdrop.b5bfefe1.png";